export default "__VITE_ASSET__BK05Rwas__"